<div class="footer" *ngIf="(buildVersion$ | async)">
  <span id="footerReleaseVersion" class="append-color">V-{{(buildVersion$ | async)}}</span>Copyright &copy; Meridian IT Inc. {{year}} All Rights Reserved.
</div>
